export default {
	packageType: 'Flexible'
};
